const ORDER_STATE = {
  PROCESSING: 0,
  SUCCESS: 1,
  FAILED: 2,
};

const ORDER_STATUS = {
  PAID: 'PAID',
  PENDING: 'PENDING',
  CANCEL: 'CANCEL',
};

const HAVE_NO_ORDER = 'HAVE_NO_ORDER';

const CANCEL_ORDER_TIMER = {
  BANK_TRANSFER: 2, // hours
  ONLINE_GATEWAY: 15 * 60, // second
};

const CANCEL_REASON = [
  { key: 'CHANGE_PAYMENT_METHOD', label: 'changePaymentMethod' },
  { key: 'CHANGE_PROMOTION', label: 'changePromotion' },
  { key: 'CHANGE_PACKAGE', label: 'changePackage' },
  { key: 'HIGH_PRICE', label: 'highPrice' },
  { key: 'PURCHASED_ELSEWHERE', label: 'purchasedElsewhere' },
  { key: 'PAID_BUT_NOT_ACTIVATED', label: 'paidButNotActivated' },
  { key: 'NO_NEED', label: 'noNeed' },
  { key: 'OTHER', label: 'other' },
];

export {
  ORDER_STATE,
  ORDER_STATUS,
  HAVE_NO_ORDER,
  CANCEL_ORDER_TIMER,
  CANCEL_REASON,
};
